import {PrototypeSpinResult} from '@fantasmagames/slot/src/logic/prototype/PrototypeSpinResult';
import {RespinScatterInfo} from '@fantasmagames/slot/src/logic/SpinResult';
import {GamePrototypeAvalancheResult} from 'src/logic/prototype/GamePrototypeLogic';

export class GamePrototypeSpinResult extends PrototypeSpinResult {

	public setRespinData(avalanche: GamePrototypeAvalancheResult): void {
		this._respinScatters = [];
		for (const respin of avalanche.respins) {
			this._respinScatters.push(new RespinScatterInfo(respin.position, respin.removedPositions));
		}
	}
}



// WEBPACK FOOTER //
// ./src/logic/prototype/GamePrototypeSpinResult.ts